module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$auth.ready()) ? _c('div', {
    staticClass: "content",
    staticStyle: {
      "overflow": "auto"
    },
    style: (_vm.modalOpen === true ? 'margin-top: 12rem' : 'margin-top: 2rem')
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "columns is-centered is-gapless"
  }, [_c('div', {
    staticClass: "column is-half-tablet is-one-third-desktop"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('form', {
    attrs: {
      "id": "fromData"
    }
  }, [(_vm.step === 1) ? _c('div', {
    staticClass: "field"
  }, [_c('h2', {
    staticClass: "has-text-primary has-text-centered"
  }, [_vm._v("\n              Welcome to ChangeVU!\n            ")]), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Your email")]), _vm._v(" "), _c('p', {
    staticClass: "control has-icon"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.email),
      expression: "user.email"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "name@example.com"
    },
    domProps: {
      "value": (_vm.user.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._m(2)])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('label', {
    staticClass: "checkbox help has-text-grey"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.agree),
      expression: "user.agree"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.user.agree) ? _vm._i(_vm.user.agree, null) > -1 : (_vm.user.agree)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.user.agree,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.user, "agree", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.user, "agree", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.user, "agree", $$c)
        }
      }
    }
  }), _vm._v("\n                  I agree to the "), _c('a', {
    attrs: {
      "href": "#/terms",
      "target": "_blank"
    }
  }, [_vm._v("ChangeVU Terms of Use")])])])])]) : _vm._e(), _vm._v(" "), (_vm.step === 2) ? _c('div', {
    staticClass: "field"
  }, [_c('h2', {
    staticClass: "has-text-primary has-text-centered"
  }, [_vm._v("Check your email!")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("\n              We've sent a 6-digit confirmation code to "), _c('strong', [_vm._v(_vm._s(this.user.email))]), _vm._v(". It will expire shortly, so enter it soon.\n            ")]), _vm._v(" "), _c('Sms', {
    model: {
      value: (_vm.verificationDigits),
      callback: function($$v) {
        _vm.verificationDigits = $$v
      },
      expression: "verificationDigits"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "intro-text has-text-grey-light"
  }, [_vm._v("\n              Keep this window open while checking for your code. Remember to try your spam folder!\n            ")])], 1) : _vm._e(), _vm._v(" "), (_vm.step === 3) ? _c('div', {
    staticClass: "field"
  }, [_c('h2', {
    staticClass: "has-text-primary has-text-centered"
  }, [_vm._v("Your email is verified!")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("\n              Please add and confirm your password to complete your account set up.\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Your name")]), _vm._v(" "), _c('p', {
    staticClass: "control has-icon"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.firstName),
      expression: "user.firstName"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Your first name"
    },
    domProps: {
      "value": (_vm.user.firstName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "firstName", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._m(3)]), _vm._v(" "), _c('p', {
    staticClass: "control has-icon"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.lastName),
      expression: "user.lastName"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Your last name"
    },
    domProps: {
      "value": (_vm.user.lastName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "lastName", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._m(4)])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Password")]), _vm._v(" "), _c('p', {
    staticClass: "control has-icon"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.password),
      expression: "user.password"
    }],
    staticClass: "input",
    attrs: {
      "type": "password",
      "placeholder": "Password"
    },
    domProps: {
      "value": (_vm.user.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "password", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._m(5)]), _vm._v(" "), _c('p', {
    staticClass: "help"
  }, [_vm._v("Password should be minimum 8 characters which contain at least one numeric digit and a special character.")])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Confirm password")]), _vm._v(" "), _c('p', {
    staticClass: "control has-icon"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.confirmPassword),
      expression: "user.confirmPassword"
    }],
    staticClass: "input",
    attrs: {
      "type": "password",
      "placeholder": "Confirm password"
    },
    domProps: {
      "value": (_vm.user.confirmPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "confirmPassword", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._m(6)])])]) : _vm._e(), _vm._v(" "), (_vm.step === 4) ? _c('div', {
    staticClass: "field"
  }, [_c('h2', {
    staticClass: "has-text-primary has-text-centered"
  }, [_vm._v("\n              Two more steps!\n            ")]), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Organization name")]), _vm._v(" "), _c('p', {
    staticClass: "control has-icon"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.client.companyName),
      expression: "client.companyName"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Organization name"
    },
    domProps: {
      "value": (_vm.client.companyName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.client, "companyName", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._m(8)])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Your team name")]), _vm._v(" "), _c('p', {
    staticClass: "control has-icon"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.initiative.teamName),
      expression: "initiative.teamName"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Your team name"
    },
    domProps: {
      "value": (_vm.initiative.teamName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.initiative, "teamName", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._m(9)])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("\n                Initiative name\n                "), _c('span', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.top",
      value: ('Please add initiative, project or other program name.'),
      expression: "'Please add initiative, project or other program name.'",
      modifiers: {
        "top": true
      }
    }],
    staticClass: "tooltip"
  }, [_c('i', {
    staticClass: "fa fa-question-circle"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "control has-icon"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.initiative.initiativeName),
      expression: "initiative.initiativeName"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Initiative name"
    },
    domProps: {
      "value": (_vm.initiative.initiativeName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.initiative, "initiativeName", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._m(10)])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("\n                Assessment due date\n                "), _c('span', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.top",
      value: ('Date to complete assessment for all members.'),
      expression: "'Date to complete assessment for all members.'",
      modifiers: {
        "top": true
      }
    }],
    staticClass: "tooltip"
  }, [_c('i', {
    staticClass: "fa fa-question-circle"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "control has-icon deadlineInput"
  }, [_c('datetime', {
    attrs: {
      "min-datetime": new Date().toISOString(),
      "max-datetime": new Date(Date.now() + 90 * 24 * 60 * 60 * 1000).toISOString(),
      "use12-hour": true,
      "type": "datetime",
      "minute-step": 15,
      "auto": true,
      "format": {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
        timeZoneName: 'short'
      },
      "placeholder": _vm.datePlaceholder
    },
    model: {
      value: (_vm.initiative.deadline),
      callback: function($$v) {
        _vm.$set(_vm.initiative, "deadline", $$v)
      },
      expression: "initiative.deadline"
    }
  }), _vm._v(" "), _vm._m(11)], 1)])]) : _vm._e(), _vm._v(" "), (_vm.step === 5) ? _c('div', {
    staticClass: "field"
  }, [_c('h2', {
    staticClass: "has-text-primary has-text-centered"
  }, [_vm._v("\n              Last step!\n            ")]), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._m(12), _vm._v(" "), _c('p', {
    staticClass: "control has-text-right"
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.previewModal()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-list-alt"
  }), _vm._v(" Email Preview\n              ")])]), _vm._v(" "), _vm._l((_vm.members), function(input, k) {
    return _c('div', {
      key: k,
      staticClass: "field"
    }, [_c('p', {
      staticClass: "control has-icons-left has-icons-right"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.members[k].email),
        expression: "members[k].email"
      }],
      staticClass: "input",
      attrs: {
        "type": "text",
        "placeholder": "name@example.com"
      },
      domProps: {
        "value": (_vm.members[k].email)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.members[k], "email", $event.target.value)
        }
      }
    }), _vm._v(" "), _vm._m(13, true), _vm._v(" "), _c('span', {
      staticClass: "icon is-small is-right"
    }, [_c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (k || (!k && _vm.members.length > 1)),
        expression: "k || ( !k && members.length > 1)"
      }],
      staticClass: "fa fa-times-circle",
      on: {
        "click": function($event) {
          return _vm.remove(k)
        }
      }
    })])]), _vm._v(" "), _c('p', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.members.length <= 9),
        expression: "members.length <= 9"
      }],
      staticClass: "control has-text-right"
    }, [_c('a', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (k === _vm.members.length - 1),
        expression: "k === members.length-1"
      }],
      on: {
        "click": function($event) {
          return _vm.add(k)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-plus-circle"
    }), _vm._v(" Add another\n                ")])])])
  }), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.members.length > 9),
      expression: "members.length > 9"
    }],
    staticClass: "help"
  }, [_vm._v("\n              You can add a maximum of 10 team members in the free risk assessment. "), _c('a', {
    on: {
      "click": function($event) {
        return _vm.contactModal()
      }
    }
  }, [_vm._v("Contact us")]), _vm._v(" to upgrade.\n            ")])], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('p', {
    staticClass: "control progress-btn",
    class: {
      'btnCenter': _vm.step !== 1
    }
  }, [(_vm.step === 1) ? _c('span', {
    staticClass: "step1msg"
  }, [_c('p', {
    staticClass: "red"
  }, [_vm._v("No credit card required")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/login"
    }
  }, [_vm._v("Already have a free trial account?")])]) : _vm._e(), _vm._v(" "), (_vm.step === 1) ? _c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.onBoard(1)
      }
    }
  }, [_vm._v("Next  "), _c('i', {
    staticClass: "fa fa-chevron-right"
  })]) : _vm._e(), _vm._v(" "), (_vm.step === 2) ? _c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.onBoard(2)
      }
    }
  }, [_vm._v("Confirm")]) : _vm._e(), _vm._v(" "), (_vm.step === 3) ? _c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.onBoard(3)
      }
    }
  }, [_vm._v("Next  "), _c('i', {
    staticClass: "fa fa-chevron-right"
  })]) : _vm._e(), _vm._v(" "), (_vm.step === 4) ? _c('button', {
    staticClass: "button is-primary btnRight",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.onBoard(4)
      }
    }
  }, [_vm._v("Next  "), _c('i', {
    staticClass: "fa fa-chevron-right"
  })]) : _vm._e(), _vm._v(" "), (_vm.step === 5) ? _c('button', {
    staticClass: "button is-primary btnRight",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.onBoard(5)
      }
    }
  }, [_vm._v("Done "), _c('span', {
    staticClass: "is-hidden-mobile"
  }, [_vm._v("& Do My Assessment")]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-chevron-right"
  })]) : _vm._e()])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal previewModal",
    class: {
      isActive: _vm.modalOpen
    }
  }, [_c('div', {
    staticClass: "modal-background"
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "box is-paddingless"
  }, [_c('div', {
    staticClass: "preview-header has-text-centered"
  }, [_c('img', {
    attrs: {
      "src": "https://www.changevu.com/img/logo2x.png",
      "href": "https://www.changevu.com/",
      "alt": "ChangeVU",
      "width": "150px"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "delete",
    attrs: {
      "aria-label": "close"
    },
    on: {
      "click": function($event) {
        return _vm.closeModal()
      }
    }
  })]), _vm._v(" "), _vm._m(14), _vm._v(" "), _c('div', {
    staticClass: "preview-body has-text-white"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('h2', {
    staticClass: "has-text-white"
  }, [_vm._v("\n              You've been invited to join ChangeVU's change risk assessment.\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n              " + _vm._s(this.user.firstName) + " invited you to run a team change risk assessment.\n            ")]), _vm._v(" "), _vm._m(15), _vm._v(" "), _c('p', [_vm._v("\n              You have until " + _vm._s(this.initiative.deadline) + " to complete the assessment."), _c('br'), _vm._v("\n              You will then receive your individual and team reports.\n            ")]), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "width": "125px"
    }
  }, [_vm._v("Team Name:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(this.initiative.teamName))])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "width": "125px"
    }
  }, [_vm._v("Team Leader:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(this.user.firstName) + " " + _vm._s(this.user.lastName))])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "width": "125px"
    }
  }, [_vm._v("Initiative name:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(this.initiative.initiativeName))])])])])])]), _vm._v(" "), _vm._m(16), _vm._v(" "), _vm._m(17), _vm._v(" "), _vm._m(18)])])]), _vm._v(" "), _c('div', {
    staticClass: "modal contactModal",
    class: {
      isActive: _vm.contactModalOpen
    }
  }, [_c('div', {
    staticClass: "modal-background"
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('h2', {
    staticClass: "is-title is-bold has-text-centered has-text-primary"
  }, [_vm._v("\n              Contact Us\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "delete",
    attrs: {
      "aria-label": "close"
    },
    on: {
      "click": function($event) {
        return _vm.closeContactModal()
      }
    }
  })]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('form', [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Your Message")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.message),
      expression: "message"
    }],
    staticClass: "textarea",
    attrs: {
      "rows": "3",
      "placeholder": "Your Message"
    },
    domProps: {
      "value": (_vm.message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.message = $event.target.value
      }
    }
  })])]), _vm._v(" "), (_vm.message) ? _c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "control has-text-centered"
  }, [_c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.contactSubmit()
      }
    }
  }, [_vm._v("Send")])])]) : _vm._e(), _vm._v(" "), (!_vm.message) ? _c('div', {
    staticClass: "field"
  }, [_vm._m(19)]) : _vm._e()])])])])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('h1', {
    staticClass: "has-text-centered has-text-white"
  }, [_c('span', {
    staticStyle: {
      "color": "yellow"
    }
  }, [_vm._v("FREE TRIAL! TEAM CHANGE RISK ASSESSMENT")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("\n              Please enter your email address. "), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "grey",
      "font-size": "0.75rem"
    }
  }, [_vm._v("(Your email is safe with us. We will not spam you.)")]), _vm._v(" "), _c('br'), _vm._v("\n              Create your account and assessment date. "), _c('br'), _vm._v("\n              Invite team members & run your free trial!\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-lock"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-user"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-user"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-lock"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-lock"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("\n              Please add initiative information (below). "), _c('br'), _vm._v("\n              Then add team members (next page)..."), _c('br'), _vm._v("\n              ...and you're ready to go!"), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-building"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-users"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-address-book"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-calendar"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("\n              Please add your team member’s email addresses."), _c('br'), _vm._v("\n              They will automatically be invited to the assessment.\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small is-left"
  }, [_c('i', {
    staticClass: "fa fa-envelope"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "preview-banner has-text-centered"
  }, [_c('img', {
    attrs: {
      "src": "https://www.changevu.com/img/banners/changeLeaders.jpg",
      "href": "https://www.changevu.com/",
      "alt": "ChangeVU"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n              Click the link below to accept the invitation."), _c('br'), _vm._v("\n              Validate your email and password to access the change risk assessment.\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "preview-body-button"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('p', {
    staticClass: "has-text-centered"
  }, [_c('button', {
    staticClass: "button is-primary has-text-black"
  }, [_vm._v("Accept Invitation")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "preview-body has-text-white"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('p', [_vm._v("\n              Welcome to ChangeVU!"), _c('br'), _c('br'), _vm._v("\n              Thanks,"), _c('br'), _vm._v("ChangeVU Team\n            ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "preview-footer"
  }, [_c('div', {
    staticClass: "footer-img"
  }, [_c('img', {
    attrs: {
      "src": "https://x5n8g.mjt.lu/tplimg/x5n8g/b/xzs81/oi9i.jpeg",
      "alt": "Connect to better change navigation"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "has-text-centered"
  }, [_c('a', {
    staticStyle: {
      "color": "#9B9B9B"
    },
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Unsubscribe")]), _vm._v(" to stop receiving these emails from us."), _c('br'), _vm._v("\n            Straticom Technologies R&D, 931 Lake Drive North, Georgina, Ontario, L4P3E9"), _c('br'), _vm._v("\n            © 2020 Straticom Technologies R&D, all rights reserved.\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "control has-text-centered"
  }, [_c('button', {
    staticClass: "button is-primary",
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Send")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cdb0e7d0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/views/auth/OnBoard.vue
// module id = 385
// module chunks = 5